import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme, _, classes: any) => {
    return {
        input: {
            '& input': {
                cursor: 'pointer',
            },
            '& .MuiInputBase-input': {
                textTransform: 'lowercase',
            },
            '& .Mui-focused:after': {
                transform: 'scaleX(0) !important',
            },
            '& .MuiInput-root': {
                marginTop: '12px',
            },
            '& label': {
                color: `${theme.palette.secondary[700]} !important`,
                fontSize: `${theme.typography.caption.fontSize}px !important`,
                lineHeight: '1.15 !important',
                transform: 'none',
            },
        },
        isRequired: {
            '& .MuiInputBase-input': {
                backgroundColor: theme.palette.primary[30],
            },
        },
        requiredMark: {
            position: 'absolute',
            left: -6,
            width: 4,
            height: 26,
            backgroundColor: theme.palette.primary.main,
            borderRadius: 3,
        },
        disabled: {
            [`& .${classes.requiredMark}`]: {
                backgroundColor: 'transparent !important',
            },
            '& .MuiInputBase-input': {
                backgroundColor: 'transparent !important',
            },
            [`& .${classes['MuiInput-underline:before']}`]: {
                border: '0 !important',
            },
        },
        calendarHeader: {
            '& span.MuiTypography-subtitle1': {
                fontWeight: '500',
                opacity: 1,
                lineHeight: '19px',
                color: theme.palette.secondary[900],
            },
        },
    }
})

export default useStyles
